import React from "react";
import "./Form.css";

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formFilledData: {}
    };
  }
  handleRadioClick = (questionId, answerId) => {
    const updatedData = {
      ...this.state.formFilledData,
      [questionId]: answerId
    }
    this.setState({ formFilledData: updatedData });
  }
  boolRadioSelected = (questionId, answerId) => {
    return !!this.state.formFilledData[questionId] && this.state.formFilledData[questionId] === answerId
  }
  renderRadio = (answer, questionId, key) => {
    return (
      <div className="radioRoot" key={key} onClick={this.handleRadioClick.bind(this, questionId, answer.answer_id)}>
        <div className="radio">
          {
            this.boolRadioSelected(questionId, answer.answer_id) && <div className="radioSelected" />
          }
        </div>
        <p>{answer.value}</p>
      </div>
    );
  }
  renderAnswers = (answers = [], questionId) => {
    return answers.map((answer, index) => this.renderRadio(answer, questionId, `form_answer_${index}_${answer.answer_id}`));
  }
  renderQuestions = () => {
    return ((this.props.formData || []).map((question, index) => (
      <div
        key={`form_question_${index}`}
        className="question"
      >
        <h2>{question.value}</h2>
        <div className="answersWrapper">
          {this.renderAnswers(question.answers, question.question_id)}
        </div>
      </div>
    )));
  }
  boolShowSubmit = () => {
    const allQuestionIds = (this.props.formData || []).map((question) => question.question_id);
    const allAnsweredQuestionIds = Object.keys(this.state.formFilledData);
    return (allQuestionIds || []).every(id => allAnsweredQuestionIds.includes(id));
  }
  handleSubmitClick = () => {
    const data = {
      submitted_form: Object.keys(this.state.formFilledData).map(quesId => ({
        question_id: quesId,
        answer_ids: [ this.state.formFilledData[quesId] ]
      }))
    };

    this.props.onSubmit(data);
  }
  render() {
    const data = this.props.formData || [];
    return (
      <div className="formRoot">
        <div className="questionsContainer">
          {this.renderQuestions()}
        </div>
        {
          this.boolShowSubmit() && data.length > 0 && (
            <div className="submitButtonWrapper" onClick={this.handleSubmitClick}>
              <div>Submit</div>
            </div>
          )
        }
      </div>
    );
  }
}

export default Form;
